import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import { Card, Typography } from '@material-ui/core';
import { Formatters } from '../../../Utils/Formatters';

const Memberships = ({ activeMemberships }) => (
  <Card>
    <Typography variant="h5" component="h2" className="centered message" style={{paddingTop: '10px'}}>
      Membresías
    </Typography>
    <List>
      {activeMemberships.length === 0 && <p className="centered">No hay membresías disponibles.</p>}
      {activeMemberships.map(membership => <ListItem key={membership.id}>
        <Avatar>
          <PersonIcon />
        </Avatar>
        <ListItemText primary={membership.freq.detail} secondary={`Vencimiento: ${Formatters.formatDate(membership.end_at)}`} />
      </ListItem>
      )}
    </List>
  </Card>
);

export default Memberships;
